export default __webpack_public_path__ + "static/vaishnavi-60ab54188960235669dde0581470f5f1.png";